import { type FormEvent, useId, useRef, useState } from "react";
import { Link } from "react-router";
import { contactEmails } from "../../config/contact";

export function SupplierJoinForm() {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");
  const [reference, setReference] = useState("");
  const requestId = useRef<string | null>(null);
  const sending = useRef(false);
  const statusId = useId();

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (sending.current || reference) return;
    const form = event.currentTarget;
    if (!form.reportValidity()) return;
    const body = new FormData(form);
    requestId.current ??= crypto.randomUUID();
    body.set("submissionId", requestId.current);
    body.set("language", "fa");
    body.set("kind", "partnership");
    body.set("consent", "yes");
    body.set("market", String(body.get("targetMarkets") ?? ""));
    body.set("message", String(body.get("description") ?? ""));
    sending.current = true;
    setBusy(true);
    setStatus("در حال ارسال اطلاعات…");
    try {
      const response = await fetch("/api/enquiries", { method: "POST", body, signal: AbortSignal.timeout(30000) });
      const result = await response.json() as { ok?: boolean; reference?: string };
      if (!response.ok || !result.ok || !result.reference) throw new Error();
      setReference(result.reference);
      setStatus("اطلاعات شرکت برای بررسی به تیم IranTradeReach ارسال شد. پاسخ از طریق ایمیل یا شماره تماس ثبت‌شده انجام می‌شود.");
    } catch {
      setStatus("ارسال اطلاعات تأیید نشد. لطفاً دوباره تلاش کنید یا اطلاعات را مستقیماً برای ما ایمیل کنید.");
    } finally {
      sending.current = false;
      setBusy(false);
    }
  };

  return (
    <form className="enquiry-form supplier-join-form" onSubmit={submit} onChange={() => { if (!sending.current) { requestId.current = null; setStatus(""); } }} aria-busy={busy}>
      {reference ? <div className="enquiry-success" role="status"><h2>اطلاعات شما دریافت شد.</h2><p>{status}</p><p className="enquiry-reference">شماره پیگیری: <bdi>{reference}</bdi></p></div> : <fieldset disabled={busy}>
        <div className="rfq-form-row">
          <label>نام شرکت<input name="company" autoComplete="organization" required maxLength={160} /></label>
          <label>نام و نام خانوادگی<input name="name" autoComplete="name" required maxLength={120} /></label>
        </div>
        <div className="rfq-form-row">
          <label>سمت<input name="position" autoComplete="organization-title" required maxLength={120} /></label>
          <label>شماره تماس<input name="phone" type="tel" autoComplete="tel" required maxLength={40} inputMode="tel" /></label>
        </div>
        <div className="rfq-form-row">
          <label>ایمیل<input name="email" type="email" autoComplete="email" required maxLength={254} dir="ltr" /></label>
          <label>وب‌سایت<input name="companyWebsite" type="url" autoComplete="url" required maxLength={240} placeholder="https://example.com" dir="ltr" /></label>
        </div>
        <div className="rfq-form-row">
          <label>استان<input name="province" autoComplete="address-level1" required maxLength={100} /></label>
          <label>حوزه فعالیت<input name="activity" required maxLength={180} /></label>
        </div>
        <label>محصولات اصلی<textarea name="products" required maxLength={2500} placeholder="نام محصولات، مشخصات اصلی و ظرفیت تولید را به‌اختصار بنویسید." /></label>
        <label>سابقه صادرات <span>(اختیاری)</span><textarea name="exportHistory" maxLength={2000} placeholder="کشورها، محصولات یا تجربه‌های مرتبط" /></label>
        <label>بازارهای هدف <span>(اختیاری)</span><textarea name="targetMarkets" maxLength={1200} placeholder="کشورها یا بازارهایی که برای توسعه آنها برنامه دارید" /></label>
        <label>توضیحات<textarea name="description" required maxLength={5000} placeholder="هر نکته‌ای که برای ارزیابی اولیه همکاری ضروری است." /></label>
        <div className="enquiry-trap" aria-hidden="true"><label>این فیلد را خالی بگذارید<input name="website" tabIndex={-1} autoComplete="off" /></label></div>
        <label className="enquiry-consent"><input type="checkbox" required /><span>با استفاده از اطلاعات ارسالی برای بررسی و پاسخ‌گویی موافقم و <Link to="/fa/privacy-policy" target="_blank" rel="noopener">سیاست حفظ حریم خصوصی</Link> را مطالعه کرده‌ام.</span></label>
        <button className="button" type="submit" disabled={busy} aria-describedby={status ? statusId : undefined}>{busy ? "در حال ارسال…" : "ارسال اطلاعات شرکت"}</button>
      </fieldset>}
      {!reference ? <p id={statusId} className={`form-status ${status && !busy ? "is-error" : ""}`} role="status">{status}</p> : null}
      <p className="enquiry-direct">ارسال مستقیم از طریق ایمیل: <a href={`mailto:${contactEmails.partnership}`}>{contactEmails.partnership}</a></p>
    </form>
  );
}
